import { render, staticRenderFns } from "./TurnAblePanel.vue?vue&type=template&id=79fcd6da&scoped=true&"
import script from "./TurnAblePanel.vue?vue&type=script&lang=js&"
export * from "./TurnAblePanel.vue?vue&type=script&lang=js&"
import style0 from "./TurnAblePanel.vue?vue&type=style&index=0&id=79fcd6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fcd6da",
  null
  
)

export default component.exports